import { ActionButtonFormType, getActionButtonForm } from './ActionButtonFormMap';

interface AritoInputTableActionFormButtonsProps {
  onAddForm?: () => void;
  onEditForm?: () => void;
}

interface DefaultAddEditActionFormButtonsProps extends AritoInputTableActionFormButtonsProps {
  errorMessage?: string;
  tableActionButtonsForm?: ActionButtonFormType[];
}

export default function AddEditActionFormButtons({
  onAddForm,
  onEditForm,
  errorMessage,
  tableActionButtonsForm
}: DefaultAddEditActionFormButtonsProps) {
  // Default action buttons if none are specified
  const defaultButtons: ActionButtonFormType[] = ['add', 'edit'];

  // Use provided buttons or default ones
  const buttons = tableActionButtonsForm || defaultButtons;

  return (
    <div className='flex h-full flex-1 items-center justify-between'>
      <div className='flex items-center'>
        {buttons.map((buttonType, index) => (
          <span key={buttonType + index}>
            {getActionButtonForm(buttonType, {
              onAddForm,
              onEditForm
            })}
          </span>
        ))}
      </div>

      {errorMessage && <div className='ml-2 text-xs font-medium text-red-500'>{errorMessage}</div>}
    </div>
  );
}
